import React from "react";
import LegalPage from "./LegalPage";

export default function DataDeletion() {
  return (
    <LegalPage title="User Data Deletion Instructions">
      <p><strong>Last updated:</strong> September 7, 2026</p>

      <p>
        If you would like personal information associated with your use of
        Wellora AI to be deleted, you may submit a deletion request to the
        organization that collected your information through Wellora AI.
      </p>

      <h3>How to request deletion</h3>
      <p>
        Contact the relevant Wellora AI business administrator and clearly state
        that you are requesting deletion of your personal information. Include
        enough information to identify your record, such as your name, phone
        number or email address.
      </p>

      <h3>What happens next</h3>
      <p>
        The organization will verify the request where appropriate and delete
        eligible personal information from active Wellora AI records, subject to
        legal, contractual, fraud-prevention, security and record-retention
        requirements.
      </p>

      <h3>Third-party platforms</h3>
      <p>
        Data held independently by third-party services such as Meta or WhatsApp
        may be subject to their own deletion processes and retention policies.
      </p>
    </LegalPage>
  );
}
